/**
 * top-illust セクションの段階フェードイン演出。
 *
 * - Stage 1-3: section.top が viewport.top に到達した瞬間に section へ `.illust-anim-active` を付与。
 *   Lottie pop-in → 装飾写真 fade-up → 背景うねり線 blur 解除、 という順序は CSS 側で
 *   transition-delay (Stage1=0, Stage2=500ms, Stage3=1600ms + --anim-sp/--anim-pc * stagger) で表現。
 * - Stage 4: 3 機能カードは scroll に同期した scrub 方式。 カード上端が viewport.bottom に
 *   到達した時点で raw progress 0、 viewport の中央 (vh*0.5) に到達した時点で raw 1。
 *   各カードに --anim-pc / --anim-sp の順序 (1-3) に応じた offset を掛けて、 左 (SP 上) から
 *   順次始まる stagger を実現。 一方通行 (progress は単調増加で減らさない)。
 * - 底部折り鶴 Lottie ([data-illust-tsuru]): 鶴の中心が viewport 中央付近 (±20%) に来た時の
 *   scroll イベントで 1 回再生 (上下スクロール問わず)。 再生中は play 要求を無視し、
 *   complete で再度待機状態に戻る。
 *
 * 既存の fade-in-on-scroll.js / top-about-pin.js とは独立に動作する。
 */
(function () {
  'use strict';

  function init() {
    var section =
      document.querySelector('#shopify-section-top_illust section') ||
      document.querySelector('[id*="top_illust"] section');
    if (!section) return;

    /* Stage 1-3: section.top が viewport 上端から 70% 下 (= 画面の下から 30%) に達したら active 化。
       ユーザーが illust に到達する前から演出を走らせて、 セクション到達時に違和感なく見せる。 */
    function activate() {
      var rect = section.getBoundingClientRect();
      if (rect.top <= window.innerHeight * 0.7) {
        section.classList.add('illust-anim-active');
        window.removeEventListener('scroll', activate);
      }
    }
    window.addEventListener('scroll', activate, { passive: true });
    activate();

    /* Stage 4: 3 機能カードを scroll に同期して fade-in (scrub)。
       一度進んだ progress は維持して戻りスクロールでも opacity を下げない (一方通行)。 */
    var cards = section.querySelectorAll('[data-illust-anim="card"]');
    if (!cards.length) return;
    var maxProgress = new WeakMap();
    var rafId = null;

    var isPc = window.matchMedia('(min-width: 60rem)').matches;
    function updateCards() {
      rafId = null;
      var vh = window.innerHeight;
      var start = vh;          /* 発火位置: カード上端が画面下端に到達 */
      var end = vh * 0.5;      /* 完了位置: カード上端が画面中央に到達 */
      cards.forEach(function (card) {
        var rect = card.getBoundingClientRect();
        var raw = (start - rect.top) / (start - end);
        /* 左 (SP 上) から順次始める stagger。 order 1 → offset 0、 2 → 0.2、 3 → 0.4。
           raw が offset を超えた分だけ自カードの progress として進む (残り scale で正規化)。 */
        var orderAttr = isPc ? '--anim-pc' : '--anim-sp';
        var order = parseInt(card.style.getPropertyValue(orderAttr) || '1', 10);
        var offset = (order - 1) * 0.2;
        var scale = 1 - offset;
        var progress = Math.max(0, Math.min(1, (raw - offset) / scale));
        var prev = maxProgress.get(card) || 0;
        if (progress < prev) progress = prev;
        else maxProgress.set(card, progress);
        card.style.opacity = progress;
        card.style.transform = 'translateY(' + (24 * (1 - progress)) + 'px)';
      });
    }
    function schedule() {
      if (rafId != null) return;
      rafId = window.requestAnimationFrame(updateCards);
    }
    updateCards();
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });

    /* 底部折り鶴 Lottie: scroll で鶴の中心が viewport 中央 ±20% に入った瞬間に 1 回再生。
       isPlaying フラグで重複再生を防ぎ、 complete で false に戻して次のスクロールで再再生可能に。 */
    var tsuruWrap = section.querySelector('[data-illust-tsuru]');
    var tsuruPlayer = tsuruWrap && tsuruWrap.querySelector('lottie-player');
    if (tsuruWrap && tsuruPlayer) {
      var isTsuruPlaying = false;
      tsuruPlayer.addEventListener('complete', function () {
        isTsuruPlaying = false;
      });
      function checkTsuru() {
        if (isTsuruPlaying) return;
        var rect = tsuruWrap.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var vh = window.innerHeight;
        if (Math.abs(center - vh / 2) < vh * 0.2) {
          isTsuruPlaying = true;
          tsuruPlayer.stop();
          tsuruPlayer.play();
        }
      }
      window.addEventListener('scroll', checkTsuru, { passive: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
